export type AppRole = "admin" | "supersupervisor" | "supervisor";
export type Permission = "view" | "edit" | "delete";

export class RoleService {
  private getUser(): any {
    const raw = sessionStorage.getItem("userSession");
    return raw ? JSON.parse(raw) : null;
  }

  /**
   * Backend role mapping:
   * 1 → admin
   * 7 → supersupervisor
   * 2 → supervisor
   */
  getRoleId(): number | null {
    return this.getUser()?.user_role_id?.[0] ?? null;
  }

  getRole(): AppRole | null {
    switch (this.getRoleId()) {
      case 1:
        return "admin";
      case 7:
        return "supersupervisor";
      case 2:
        return "supervisor";
      default:
        return null;
    }
  }

  // PERMISSIONS

  canView(): boolean {
    return this.isAuthenticated();
  }

  canEdit(): boolean {
    return this.isAdmin() || this.isSuperSupervisor();
  }

  canDelete(): boolean {
    return this.isAdmin();
  }

  // ROLE HELPERS

  isAdmin(): boolean {
    return this.getRoleId() === 1;
  }

  isSuperSupervisor(): boolean {
    return this.getRoleId() === 7;
  }

  isSupervisor(): boolean {
    return this.getRoleId() === 2;
  }

  isAuthenticated(): boolean {
    return !!this.getUser();
  }
}
